package com.essntl.features.invoice.ui.addeditinvoice.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceEvent
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceValidation
import com.essntl.features.invoice.ui.addeditinvoice.components.sidebar.InvoicingTotalSection
import com.essntl.uikit.components.utils.EsConstants

@Composable
fun AddEditInvoiceSideBar(
    state: AddEditInvoiceState,
    validation: AddEditInvoiceValidation,
    onEvent: (AddEditInvoiceEvent) -> Unit,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius)),
    ) {
        InvoicingTotalSection(
            state = state,
            validation = validation,
            onEvent = onEvent,
        )
    }
}